<template>
  <div
    class="room"
    :class="{ 'is-open': isOpen }"
  >
    <div
      class="info"
      @click="trigger"
    >
      <div class="img">
        <img
          :src="img || '/images/content/img-no-room-placeholder.jpg'"
          :alt="name"
        >
      </div>
      <div class="name">
        {{ name }}
      </div>
      <div
        v-if="sourcesList && sourcesList.length"
        class="sources"
      >
        <span class="sources-label">
          {{ sourcesList.length }} {{ sourcesList.length > 1 ? 'sources' : 'source' }}
        </span>
      </div>
      <div class="actions">
        <button
          class="disable"
          @click.prevent.stop
        >
          Disable
        </button>
        <span class="arrow">Open</span>
      </div>
    </div>
    <div class="sources-list">
      <data-table
        :headers="sourcesHeaders"
        :rows="sourcesList"
      />
    </div>
  </div>
</template>

<script>
import DataTable from './DataTable';

export default {
  name: 'all-rooms-list',
  components: {
    DataTable,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    img: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
      default: '',
    },
    sourcesHeaders: {
      type: Array,
      default: null,
    },
    sourcesList: {
      type: Array,
      default: null,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    trigger() {
      this.$emit('open', this.id);
    },
  },
};
</script>

<style scoped lang="scss">
.room {
  &.is-open {
    .info {
      background-color: #f7f9fc;
    }
    .sources-list {
      max-height: 230px;
      overflow: auto;
    }
  }
}

.info {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #fff;
  border-bottom: 1px solid rgba(#6e7c91, .07);
  cursor: pointer;
  .no-touchevents &:hover {
    background-color: #f7f9fc;
  }

  .img {
    width: 60px;
    height: 40px;
    margin-right: 18px;
    position: relative;

    img {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }

  .name {
    margin-right: 18px;
    color: #6e7c91;
    font-size: 15px;
    font-weight: 500;
  }

  .sources {
    flex-grow: 1;
    margin-right: 18px;

    .sources-label {
      padding: 8px;
      border-radius: 3px;
      background-color: rgba(#6972de, .2);
      color: #6972de;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
}

.actions {
  display: flex;

  .disable {
    padding: 8px;
    border: none;
    border-radius: 3px;
    background-color: #f96c6c;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    margin-right: 10px;
    cursor: pointer;
    &:focus {outline: none;}
  }

  .arrow {
    width: 28px;
    font-size: 0;
    background-image: url('../assets/icons/arrow-right.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px auto;
  }
}

.sources-list {
  padding: 0 24px;
  max-height: 0;
  overflow: hidden;
  transition: max-height .3s;
}
</style>
